import './Button.css';

const Button = ({ children, onClick }) => {
  
  return (
    <button className="attractive-button" onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
